import { getGenericEndpoint } from './get.api';
import type { GetSigninResponse } from './types';

type ProvideType = 'email' | 'mobile';

export const getProvide = async (type: ProvideType, lang?: string) => {
	return await getGenericEndpoint<GetSigninResponse>(
		`signin/provide-${type}`,
		lang
	);
};
